import { createFileRoute, Navigate } from '@tanstack/react-router';

const AdminRedirectPage = () => {
  return <Navigate to='/operators/dashboard' replace />;
};

export const Route = createFileRoute('/admin')({
  component: AdminRedirectPage,
});
